// extracted by mini-css-extract-plugin
export default {"paragraphBreak":"ParagraphBreak_paragraphBreak__FOklv","paragraphButton":"ParagraphBreak_paragraphButton__kWvt2","paragraphLine":"ParagraphBreak_paragraphLine__WL41v"};